import router from './routes/routes'
import locales from './locales/locales'

export const AddressChangesModule = {
    name: "addressChanges",
    routes: router,
    locales: locales,
}